import React from 'react'
import styles from './WrestlerSmallView.module.scss'
import { DesktopBodyLarge, DesktopTitleLarge } from '../../Typography'
import { mapTitleToChampionString, Title } from './Title'

interface TagChampsSmallViewProps {
  profilbilder: string[]
  namen: string[]
  firstStables: string[]
  secondStables: string[]
  onFirstClick: () => void
  onSecondClick: () => void
}

export const TagChampsSmallView: React.FC<TagChampsSmallViewProps> = ({
  profilbilder,
  namen,
  firstStables,
  secondStables,
  onFirstClick,
  onSecondClick,
}) => {
  const teamName =
    firstStables.find((stable) => secondStables.includes(stable) && stable !== 'Keine') ||
    `${namen[0]} & ${namen[1]}`

  return (
    <div className={styles.tagTeamContainer}>
      <div className={styles.backgroundBox}>
        <img
          className={styles.leftImage}
          src={profilbilder[0]}
          alt={'Foto von ' + namen[0]}
          onClick={(): void => {
            onFirstClick()
          }}
        />
        <img
          className={styles.rightImage}
          src={profilbilder[1]}
          alt={'Foto von ' + namen[1]}
          onClick={(): void => {
            onSecondClick()
          }}
        />
        <div className={styles.nameBand}>
          <div className={styles.nameBandContent}>
            <DesktopTitleLarge darkFont={true}>{teamName.toUpperCase()}</DesktopTitleLarge>
            <DesktopBodyLarge darkFont={true} fontWeight={600}>
              {mapTitleToChampionString(Title.TAG_TEAM_CHAMPION) + 's'}
            </DesktopBodyLarge>
          </div>
        </div>
      </div>
    </div>
  )
}
